export default __webpack_public_path__ + "static/media/awards-silmo.3c25ea3c.png";